import { render } from "./StatisticsModal.vue?vue&type=template&id=6ff76444&scoped=true"
import script from "./StatisticsModal.vue?vue&type=script&lang=js"
export * from "./StatisticsModal.vue?vue&type=script&lang=js"

import "./StatisticsModal.vue?vue&type=style&index=0&id=6ff76444&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ff76444"]])

export default __exports__